import React from "react"
import { StaticImage } from "gatsby-plugin-image"

export function SponsorButtons() {
  return (
    <ul className="flex gap-2">
      <li>
        <iframe
          src="https://github.com/sponsors/SevenOutman/button"
          title="Sponsor SevenOutman"
          height="32"
          width="114"
          style={{ border: 0, borderRadius: 6 }}
        ></iframe>
      </li>
      <li>
        <a
          href="https://afdian.net/a/doooma"
          target="_blank"
          className="inline-flex items-center gap-2 text-lg text-white py-1 pl-2 pr-4 rounded-sm"
          style={{
            height: 32,
            fontSize: 14,
            borderRadius: 6,
            backgroundColor: "#946CE6",
            fontFamily:
              "-apple-system,BlinkMacSystemFont,Helvetica Neue,Arial,PingFang SC,Hiragino Sans GB,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif",
          }}
        >
          <StaticImage
            layout="fixed"
            src="../images/afdian-logo.svg"
            width={28}
            height={28}
            quality={95}
            alt="爱发电 Logo"
            backgroundColor="transparent"
          />
          爱发电
        </a>
      </li>
    </ul>
  )
}
